import React from 'react';

import colors from '@atom/styles/colors';

const styles: Record<string, React.CSSProperties> = {
  error: {
    color: colors.utility.error,
    padding: '1rem',
    border: `1px solid ${colors.utility.errorBg}`,
    borderRadius: '0.25rem',
  },
};

const ConversationalAnalyticsChartError = () => {
  return <div style={styles.error}>Error occurred rendering visualization</div>;
};

export default ConversationalAnalyticsChartError;
